import React, {Fragment} from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {sprintf} from "sprintf-js";
import {ChecklistField, LeadChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, name, title] = [6, "BuildingExterior", "Building Exterior"];

const BuildingExteriorDefaults = () => {
    return {
        "6": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault
        }
    };
}

const BuildingExterior = () => {
    const relPath = name;
    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, title)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "foundationCondition")}
                            rank={"6.1"}
                            room={name}
                            desc={"Condition of Foundation"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "stairCondition")}
                            rank={"6.2"}
                            room={name}
                            desc={"Condition of Stairs, Rails, and Porches"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "roofCondition")}
                            rank={"6.3"}
                            room={name}
                            desc={"Condition of Roof & Gutters"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "surfaceCondition")}
                            rank={"6.4"}
                            room={name}
                            desc={"Condition of Exterior Surfaces"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "chimneyCondition")}
                            rank={"6.5"}
                            room={name}
                            desc={"Condition of Chimney"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <LeadChecklistField
                            path={sprintf("%s.%s", relPath, "leadPaint")}
                            rank={"6.6"}
                            room={name}
                            desc={"Lead-Based Paint"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "tieDowns")}
                            rank={"6.7"}
                            room={name}
                            desc={"Manufactured Home - Tie Downs"}
                            section={section}
                        />
                    </Grid>
                </CardContent>
            </Card>
        </Fragment>
    );
}

export default BuildingExterior;
export {BuildingExteriorDefaults};